import {useMutation, useQueryClient} from '@tanstack/react-query';
import {API, FieldsErrorResponse, ReservationPayload} from '@chekin/api';
import {QUERY_CACHE_KEYS,ShortReservation} from '@chekin/core';
import {useReservation} from 'context/reservation';

type useMutateReservationProps = {
  onSuccess?: (data: ShortReservation) => void;
  onError?: (error: FieldsErrorResponse) => void;
  onSettled?: () => void;
};
function useMutateReservation({
  onSuccess,
  onError,
  onSettled,
}: useMutateReservationProps = {}) {
  const queryClient = useQueryClient();
  const {data} = useReservation();
  const reservationId = data?.id;
  return useMutation<
    ShortReservation,
    FieldsErrorResponse,
    {
      payload: ReservationPayload;
    }
  >({
    mutationFn: ({payload}) =>
      API.reservation.updateReservation(reservationId as string, payload),
    onMutate: async () => {
      await queryClient.cancelQueries({
        queryKey: [QUERY_CACHE_KEYS.reservation],
      });
      await queryClient.cancelQueries({
        queryKey: [QUERY_CACHE_KEYS.guestGroup],
      });
    },
    onSuccess: data => {
      onSuccess?.(data);
      void queryClient.refetchQueries({
        queryKey: [QUERY_CACHE_KEYS.reservation],
      });
      void queryClient.refetchQueries({
        queryKey: [QUERY_CACHE_KEYS.guestGroup],
      });
    },
    onError,
    onSettled,
  });
}

export {useMutateReservation};
